import React, {Fragment} from 'react'
import styles from './SearchableCardMulti.scss'
import {PopoverMenu, PopoverMenuItem} from 'common/styleguide/PopoverMenu'
import {RadioGroup} from 'common/styleguide/RadioGroup'
import {Icon} from 'common/Icon'
import {pl} from 'lib/textUtils'

export class SearchableCardMulti extends React.PureComponent {
  render () {
    const {inputs, chips, resultsCount, resultsLength, children} = this.props
    return (
      <Fragment>
        <div className={styles.searchContainer}>
          <div className={styles.inputs}>
            {inputs}
          </div>
          {chips && <div className={styles.chips}>
            {chips}
          </div>}
          {resultsCount !== undefined && <div className={styles.resultsCount}>
            Showing {resultsLength !== resultsCount && `1 - ${resultsLength} of `} {pl(resultsCount, 'result')}
          </div>}
        </div>
        <div className={styles.resultsContainer}>
          {children}
        </div>
      </Fragment>
    )
  }
}

export class SearchableCardInput extends React.PureComponent {
  render () {
    const {
      placeholder,
      spellCheck,
      type,
      keywords,
      onKeywordChange
    } = this.props

    return (
      <div className={styles.searchInputContainer}>
        <input
          placeholder={placeholder}
          spellCheck={spellCheck || 'false'}
          type={type || 'text'}
          className={styles.searchInput}
          value={keywords}
          onChange={onKeywordChange} />
      </div>
    )
  }
}

export class SearchableCardLocationInput extends React.PureComponent {
  static defaultProps = {
    radiusControl: true,
    geolocationControl: false
  }

  constructor (props) {
    super(props)

    this.state = {
      showRadius: false
    }
  }

  toggleRadius = () => { this.setState({showRadius: !this.state.showRadius}) }

  render () {
    const {
      placeholder,
      keywords,
      onKeywordChange,
      radius,
      radiusMenuOpts,
      onRadiusChange,
      radiusControl
    } = this.props
    const {showRadius} = this.state

    return (
      <div className={styles.compositeLocationSearch}>
        <input
          placeholder={placeholder}
          spellCheck='false'
          type='text'
          className={styles.locationSearchInput}
          value={keywords}
          onChange={onKeywordChange} />
        {radiusControl && <button ref={r => { this._button = r }}
          onClick={this.toggleRadius}
          className={styles.radiusButton}>
          within <span>{radiusMenuOpts.get(radius)}</span>
        </button>}
        {radiusControl && showRadius && <PopoverMenu
          target={this._button}
          placement='bottom'
          onRequestClose={() => this.toggleRadius()}>
          <PopoverMenuItem>
            <RadioGroup
              style={{margin: '0 0'}}
              horizontal
              options={radiusMenuOpts}
              selected={radius}
              onChange={onRadiusChange} />
          </PopoverMenuItem>
        </PopoverMenu>}
      </div>
    )
  }
}

// location input that flips between a `location` string and a `lat/lng`
// pairing
export class HybridBrowserLocationInput extends React.PureComponent {
  state = {
    locatePending: false
  }

  onKeywordChange = (e) => {
    const location = e.target.value
    this.props.onLocationInputChange({lat: null, lng: null, location})
  }

  queryLocationFromBrowser = () => {
    if ('geolocation' in navigator) {
      const {lng, lat} = this.props
      this.props.onLocationInputChange({location: '', lng, lat})
      this.setState({locatePending: true})
      navigator.geolocation.getCurrentPosition(position => {
        const lng = position.coords.longitude
        const lat = position.coords.latitude
        this.setState({locatePending: false})
        this.props.onLocationInputChange({location: '', lng, lat})
      })
    }
  }

  render () {
    const {location, lat} = this.props
    const {locatePending} = this.state
    const placeholder = lat
      ? 'Current Location'
      : 'Location'
    return (
      <div className={styles.compositeLocationSearch}>
        <input
          placeholder={locatePending ? 'Locating...' : placeholder}
          spellCheck='false'
          type='text'
          className={styles.locationSearchInput}
          value={location}
          onChange={this.onKeywordChange} />
        <button
          onClick={this.queryLocationFromBrowser}
          className={styles.locateButton}>
          <Icon i='ios-locate-outline' size={22} />
        </button>
      </div>
    )
  }
}
